// apiService.ts

import { AxiosRequestConfig } from 'axios';
import axios from '../helpers/axiosInterceptor'
import { Endpoints } from '../constants/Endpoints';


export const GetUserInvoices = async (CustomerId:string) => {
  
  try {
    
    const config: AxiosRequestConfig = {
      headers: {
        'CustomerId': CustomerId??`ec3f77ab-f110-f011-9346-7c1e52e1fec5`,
        'Content-Type': 'application/json',
      }
    };
    const response:any = await axios.get(Endpoints.GetUserInvoices, config);
        // Check for unauthorized error
        if (response.data.Success === 0 && response.data.ErrorCode === 1) {
          // Handle unauthorized error, for example, redirect to login page
          console.error('Un expected error.');
          // You can redirect the user to the login page or show a login modal
          // For example, uncomment the line below to redirect to the login page
          // window.location.href = '/login';
          throw new Error('Un expected error');
        }
    
      return response.data;
    
    
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
